import { useState } from 'react'

import {
  AdUnitForTableDTO,
  QueryProps,
  QueryVariables,
} from 'features/inventory/ad-unit/components/AdUnitsTable/types/api'
import { AdUnitForTable } from 'features/inventory/ad-unit/components/AdUnitsTable/types/model'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { adUnitForTableFromDTO, sortToDTO } from './api/mapper'
import { GET_AD_UNITS_FOR_TABLE } from './api/query'
import { Data } from './api/types'
import { UseAdUnits } from './types'

export const useAdUnits = ({ filters, first, last, sort }: QueryProps): UseAdUnits => {
  const { workspaceId } = useWorkspaceParam()
  const [adUnits, setAdUnits] = useState<AdUnitForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading: loading } = useQuery<QueryVariables, Data>({
    onCompleted: async (data: Data) => {
      const {
        adUnits: { nodes: adUnits, totalCount: count },
      } = data

      if (adUnits) {
        setAdUnits(
          adUnits.map((node: AdUnitForTableDTO): AdUnitForTable => adUnitForTableFromDTO(node)),
        )
        setCount(count)
      }
    },
    query: GET_AD_UNITS_FOR_TABLE,
    variables: {
      first,
      last,
      sort: sortToDTO(sort),
      terms: filters,
      workspaceId,
    },
  })

  return {
    adUnits,
    count,
    loading,
    setAdUnits,
  }
}
